import {gql} from '@apollo/client';

import {SchemaSummary, TagSchema} from 'constants/RegistryConstants';
import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {StorableSchema} from 'samples/storables/StorableSchemaConstants';

import {SchemaInterfaceQuery} from './__generated/SchemaInterfaceQuery';

// Every tag schema paired with the ids of the schema interfaces it implements. Callers use this to
// tell which schemas satisfy a given interface without pulling the interfaces' full definitions.
export const SCHEMAS_WITH_INTERFACES_QUERY = gql`
  query SchemasWithInterfacesQuery @skipAudit @engComponent(name: SCHEMAS) {
    tagSchemas {
      id
      interfaces {
        id
      }
    }
  }
`;

export type SchemaInterface = ExtractByTypename<
  SchemaInterfaceQuery['schemaInterface'],
  'SchemaInterfaceNode'
>;

export interface SchemaInterfaceSummary extends SchemaSummary {}

export interface CustomSchemaInterfaceSummary extends SchemaInterfaceSummary {
  id: `intrfc_${string}`;
  // The fieldset's entity item type (e.g. DNA_SEQUENCE)
  itemType?: TagSchemaItemType | null;
}

export interface StaticSchemaInterfaceSummary extends SchemaInterfaceSummary {
  id: `ssi_${string}`;
}

export interface LinkableSchemas {
  tagSchemas: Array<TagSchema>;
  storableSchemas: Array<StorableSchema>;
}
